import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: window.SENTRY_DSN_FRONTEND,
  environment: window.RAILS_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
